import { IconButton, InputAdornment, TextField, Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useState } from "react";

interface PasswordFieldProps {
  name: string;
  label: string;
  value: string;
  formikError: string | undefined;
  error: boolean | undefined;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  touched: boolean | undefined;
  helperText: string;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  name,
  label,
  value,
  error,
  formikError,
  handleChange,
  touched,
  helperText,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const formikErrorMessage = touched && formikError ? formikError : "";
  const errorMessage = formikErrorMessage || helperText;
  const hasError = Boolean(errorMessage || error);
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <Box sx={{ mb: "20px" }}>
      <TextField
        placeholder={label}
        id={name}
        name={name}
        type={isVisible ? "text" : "password"}
        value={value}
        onChange={handleChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={`toggle ${name} visibility`}
                disableRipple
                onClick={toggleVisibility}
                onMouseDown={(event) => event.preventDefault()}
                tabIndex={-1}
              >
                {isVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        error={hasError}
        helperText={errorMessage}
      />
    </Box>
  );
};

export default PasswordField;
